import ModemRegisterContainer from '../../../../components/units/Management/Modem/register/modemRegisterContainer';

export default function ModemRegisterPage() {
  return <ModemRegisterContainer />;
}
